import { createBrowserHistory } from "history";
import { RouteConstants } from "../constants";
import { AppScopes } from "../models/app-scopes.model";
import { Permissions } from "../models/permission";
import Role from "../models/role";
import IRoute from "../models/route.interface";
import { OrgType } from "../models/users.interface";
import authorizationService from "../services/authorization.service";

export const browserHistory = createBrowserHistory();

export function filterRoutesByUser(
  routes: IRoute[],
  userRole: Role,
  userOrgType: OrgType | undefined,
  userPermissions: Permissions[] = []
): IRoute[] {
  return routes.filter((route) => {
    if (!userRole) return false;

    if (!route.authorizedRoles && !route.permissions) return true;

    let isAuthorized = true;

    if (route.authorizedRoles) {
      isAuthorized = authorizationService.hasRole(
        userRole,
        route.authorizedRoles
      );
    }

    if (isAuthorized && route.authorizedOrgTypes) {
      isAuthorized =
        !!userOrgType &&
        authorizationService.hasOrgType(userOrgType, route.authorizedOrgTypes);
    }

    if (isAuthorized && route.permissions) {
      const requiredPermissions = route.permissions(userRole);

      isAuthorized =
        !requiredPermissions ||
        authorizationService.hasPermissions(
          userPermissions,
          requiredPermissions
        );
    }

    if (isAuthorized && route.excludedPermissions) {
      isAuthorized = !authorizationService.hasPermissions(
        userPermissions,
        route.excludedPermissions
      );
    }

    return isAuthorized;
  });
}

export function filterRoutesByAppScopes(
  routes: IRoute[],
  appScopes?: AppScopes[]
): IRoute[] {
  if (!appScopes?.length) return routes;

  const filteredRoutes = routes.filter((route) => {
    const routeScopes = route.appScopes;
    return appScopes.some((appScope) => routeScopes?.includes(appScope));
  });

  return filteredRoutes;
}

export const getDefaultRedirectByUserRole = (
  role?: Role,
  permissions?: Permissions[]
) => {
  switch (role) {
    case Role.Reviewer:
    case Role.Professional:
    case Role.Consultant:
      return RouteConstants.ECGS_PATH;
    case Role.OrgAdmin:
      return RouteConstants.MANAGEMENT_PATH;
    case Role.OrgProfessional:
      return authorizationService.hasPermissions(permissions ?? [], [
        Permissions.CanViewEcgs,
      ])
        ? RouteConstants.ECGS_PATH
        : RouteConstants.LIMITED_PATH;
    default:
      return RouteConstants.LIMITED_PATH;
  }
};
